<template>
  <div>
    <Head title="Dashboard" />
    <h1 class="page-title">Dashboard</h1>
    <div class="grid grid-cols-1 gap-4 sm:grid-cols-2 xl:grid-cols-4">
      <Link href="/dispatch/todo" class="metric-card">
        <span class="metric-value">{{ tasks.total }}</span>
        <span class="metric-label">To Dispatch</span>
      </Link>

      <Link href="/dispatch/to_cancel" class="metric-card">
        <span class="metric-value">{{ tasks.to_cancel }}</span>
        <span class="metric-label">To Cancel</span>
      </Link>

      <div class="metric-card">
        <span v-if="tasks.sla_breaches > 0" class="metric-value text-red-600">{{ tasks.sla_breaches }}</span>
        <span v-else class="metric-value text-green-600">{{ tasks.sla_breaches }}</span>
        <span class="metric-label">SLA Breaches</span>
      </div>

      <Link href="/dispatch/done" class="metric-card">
        <span class="metric-value">{{ tasks.dispatched_today }}</span>
        <span class="metric-label">Dispatched Today</span>
      </Link>
    </div>
  </div>

  <div class="mt-8 py-3">
    <h2 class="text-lg font-bold text-gray-900">SLA Breaches</h2>
  </div>
  <div class="table-card">
    <table class="data-table">
      <thead>
        <tr class="text-left font-bold">
          <th>Order ID</th>
          <th>Confirmed At</th>
          <th>Name</th>
          <th>Order Value</th>
          <th>Delivery PIN</th>
          <th>Email</th>
          <th>Phone</th>
          <th>Status</th>
          <th />
        </tr>
      </thead>
      <tbody>
        <tr
          v-for="order in breaches.data" :id="`order_${order.id}`" :key="order.id"
          class="hover:bg-gray-100 focus-within:bg-gray-100"
        >
          <td class="border-t">
            <Link class="flex items-center px-1 py-4 focus:text-indigo-500" :href="`/dispatch/orders/${order.id}`">
              <a href="">{{ order.order_id }}</a>
            </Link>
          </td>
          <td class="border-t">
            <Link class="flex items-center px-1 py-4 focus:text-indigo-500" :href="`/dispatch/orders/${order.id}`">
              <span v-if="order.sla_breach && order.status === 'confirmed'" class="sla-chip">{{ order.date_time }}</span>
              <span v-else>{{ order.date_time }}</span>
            </Link>
          </td>
          <td class="border-t">
            <Link class="flex items-center px-1 py-4 focus:text-indigo-500" :href="`/dispatch/orders/${order.id}`">
              {{ order.name }}
            </Link>
          </td>
          <td class="border-t">
            <Link class="flex items-center px-1 py-4" :href="`/dispatch/orders/${order.id}`" tabindex="-1">
              ₹ {{ order.value }}
            </Link>
          </td>
          <td class="border-t">
            <Link class="flex items-center px-1 py-4" :href="`/dispatch/orders/${order.id}`" tabindex="-1">
<!--              {{ order.shipping_address.address_1 }}<br />-->
<!--              <span v-if="order.shipping_address.address_2">{{ order.shipping_address.address_2 }}<br /></span>-->
<!--              {{ order.shipping_address.city }}<br />-->
<!--              {{ order.shipping_address.state }} {{ order.shipping_address.postcode }}-->
              {{ order.shipping_address.zip || order.shipping_address.postcode || 'N/A' }}
            </Link>
          </td>
          <td class="border-t">
            <Link class="flex items-center px-1 py-4" :href="`/dispatch/orders/${order.id}`" tabindex="-1">
              {{ order.email }}
            </Link>
          </td>
          <td class="border-t">
            <Link class="flex items-center px-1 py-4" :href="`/dispatch/orders/${order.id}`" tabindex="-1">
              {{ order.phone_number }}
            </Link>
          </td>
          <td class="border-t">
            <span class="flex items-center px-1 py-4">
              <span v-if="order.status === 'pending'" class="pill_blue">Pending</span>
              <span v-if="order.status === 'confirmed'" class="pill_green">Confirmed</span>
              <span v-if="order.status === 'cancelled'" class="pill_red">Cancelled</span>
              <span v-if="order.status === 'followup'" class="pill_yellow">Followup</span>
              <span v-if="order.status === 'dispatched'" class="pill_grey">Completed</span>
            </span>
          </td>
          <td class="w-px border-t">
            <Link class="flex items-center px-1" :href="`/dispatch/orders/${order.id}`" tabindex="-1">
              <icon name="cheveron-right" class="block w-6 h-6 fill-gray-400" />
            </Link>
          </td>
        </tr>
        <tr v-if="breaches.data.length === 0">
          <td class="empty-state" colspan="9">No SLA breaches at the moment.</td>
        </tr>
      </tbody>
    </table>
  </div>

  <div class="mt-8 py-3">
    <h2 class="text-lg font-bold text-gray-900">New Orders</h2>
  </div>
  <div class="table-card">
    <table class="data-table">
      <thead>
        <tr class="text-left font-bold">
          <th>Order ID</th>
          <th>Confirmed At</th>
          <th>Name</th>
          <th>Order Value</th>
          <th>Delivery Address</th>
          <th>Email</th>
          <th>Phone</th>
          <th>Status</th>
          <th />
        </tr>
      </thead>
      <tbody>
        <tr
          v-for="new_order in newOrders.data" :id="`order_${new_order.id}`" :key="new_order.id"
          class="hover:bg-gray-100 focus-within:bg-gray-100"
        >
          <td class="border-t">
            <Link class="flex items-center px-1 focus:text-indigo-500" :href="`/dispatch/orders/${new_order.id}`">
              <a href="">{{ new_order.order_id }}</a>
            </Link>
          </td>
          <td class="border-t">
            <Link class="flex items-center px-1 focus:text-indigo-500" :href="`/dispatch/orders/${new_order.id}`">
              <span v-if="new_order.sla_breach && new_order.status === 'confirmed'" class="sla-chip">{{ new_order.date_time }}</span>
              <span v-else>{{ new_order.date_time }}</span>
            </Link>
          </td>
          <td class="border-t">
            <Link class="flex items-center px-1 focus:text-indigo-500" :href="`/dispatch/orders/${new_order.id}`">
              {{ new_order.name }}
            </Link>
          </td>
          <td class="border-t">
            <Link class="flex items-center px-1" :href="`/dispatch/orders/${new_order.id}`" tabindex="-1">
              ₹ {{ new_order.value }}
            </Link>
          </td>
          <td class="border-t">
            <Link class="flex items-center px-1" :href="`/dispatch/orders/${new_order.id}`" tabindex="-1">
              {{ new_order.shipping_address.address_1 }}<br />
              <span v-if="new_order.shipping_address.address_2">{{ new_order.shipping_address.address_2 }}<br /></span>
              {{ new_order.shipping_address.city }}<br />
              {{ new_order.shipping_address.state }} {{ new_order.shipping_address.zip || new_order.shipping_address.postcode }}
            </Link>
          </td>
          <td class="border-t">
            <Link class="flex items-center px-1" :href="`/dispatch/orders/${new_order.id}`" tabindex="-1">
              {{ new_order.email }}
            </Link>
          </td>
          <td class="border-t">
            <Link class="flex items-center px-1" :href="`/dispatch/orders/${new_order.id}`" tabindex="-1">
              {{ new_order.phone_number }}
            </Link>
          </td>
          <td class="border-t">
            <span class="flex items-center px-1">
              <span v-if="new_order.status === 'pending'" class="pill_blue">Pending</span>
              <span v-if="new_order.status === 'confirmed'" class="pill_green">Confirmed</span>
              <span v-if="new_order.status === 'cancelled'" class="pill_red">Cancelled</span>
              <span v-if="new_order.status === 'followup'" class="pill_yellow">Followup</span>
              <span v-if="new_order.status === 'dispatched'" class="pill_grey">Completed</span>
            </span>
          </td>
          <td class="w-px border-t">
            <Link class="flex items-center px-1" :href="`/dispatch/orders/${new_order.id}`" tabindex="-1">
              <icon name="cheveron-right" class="block w-6 h-6 fill-gray-400" />
            </Link>
          </td>
        </tr>
        <tr v-if="newOrders.data.length === 0">
          <td class="empty-state" colspan="9">No new orders at the moment.</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import {Head, Link} from '@inertiajs/inertia-vue3'
import Layout from '@/Shared/Layout'
import Icon from '@/Shared/Icon'

export default {
  components: {
    Head,
    Link,
    Icon,
  },
  layout: Layout,
  props: {
    tasks: Object,
    admin: Boolean,
    breaches: Object,
    newOrders: Object,
  },
}
</script>
